// import React, { useState } from "react";
// import moment from "moment";
// import { toast } from "react-toastify";
// import useApiRequest from "../../../../Hooks/apiReq";
// import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
// import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
// import { convertToINRFormat } from "../../../../Utils/INRConvert";
// import { APP_VERSION } from "../../../../Utils/AppVersion";
// import {
//   ResponsiveContainer,
//   ComposedChart,
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   LabelList,
// } from "recharts";

// const Business = () => {
//   const { loading, sendApiRequest } = useApiRequest();
//   const [response, setResponse] = useState({});
//   const [monthlyData, setMonthlyData] = useState([]);
//   const now = new Date();
//   const [FromDate] = useState(new Date(now.getFullYear(), now.getMonth(), 1));
//   const [ToDate] = useState(new Date());
//   const [previous, setPrevious] = useState({ fromdate: null, todate: null });

//   const fetchBusinessDetails = (from, to) => {
//     if (
//       JSON.stringify(previous) ===
//       JSON.stringify({ fromdate: from, todate: to })
//     ) {
//       toast.info("No changes in date range", { toastId: "business" });
//       return;
//     }

//     if (!from || !to) {
//       toast.warn("Please select date", { toastId: "business" });
//       return;
//     }

//     const formattedFromDate = moment(from).format("DD-MM-YYYY");
//     const formattedToDate = moment(to).format("DD-MM-YYYY");
//     sendApiRequest(
//       "POST",
//       "/Dashboard/GetBussinessCommisionRankDetails",
//       {
//         FromDate: formattedFromDate,
//         ToDate: formattedToDate,
//         DeviceType: "Web",
//         AppVersion: APP_VERSION,
//         action: "Bussiness",
//       },
//       {
//         onSuccess: (res) => {
//           setResponse(res?.data);
//           const monthlyBusiness = res?.data?.monthwiseJson
//             ? JSON.parse(res?.data?.monthwiseJson)
//             : [];
//           console.log(monthlyBusiness, "monthlyBusiness");
//           setMonthlyData(monthlyBusiness);
//         },
//       }
//     );

//     setPrevious({ fromdate: from, todate: to });
//   };

//   return (
//     <div className="col-12 col-xl-6 col-xxl-6">
//       <div className="card border h-100 w-100 overflow-hidden shadow-sm">
//         <div className="card border h-100 w-100 overflow-hidden">
//           <div className="card-body p-2  ucbd-head">
//             {/* Header */}
//             {loading && <SpinnerLoader />}

//             <div className="row">
//               <div className="col-lg-3">
//                 <h4 className="mt-2 fs-8">
//                   <span className="fas fa-building"></span> Business
//                 </h4>
//               </div>
//               <div className="col-lg-9 col-sm-auto">
//                 <div className="row g-2">
//                   <DateFilterBar onGo={fetchBusinessDetails} />
//                 </div>
//               </div>
//             </div>
//             {/* Business Summary */}
//             <div className="ucb-details mt-3">
//               <div className="ucb-current">
//                 <div className="ucb-left">
//                   <b>
//                     {convertToINRFormat(
//                       parseInt(response?.assoTotalBusiness) ?? 0
//                     )}
//                   </b>
//                   <span>Total Business</span>
//                 </div>
//                 <div className="ucb-right">
//                   <b>{response?.associateRank || "--"}</b>
//                   <span>Current Rank</span>
//                 </div>
//               </div>
//               <div className="ucb-duration">Business in Duration</div>
//               <div className="ucb-list">
//                 <b>Self Business (S.B.)</b>
//                 <span>
//                   {convertToINRFormat(
//                     parseInt(response?.totalSelfBusiness) ?? 0
//                   )}
//                 </span>
//               </div>
//               <div className="ucb-list">
//                 <b>Team Business (T.B.)</b>
//                 <span>
//                   {convertToINRFormat(
//                     parseInt(response?.totalTeamBusiness) ?? 0
//                   )}
//                 </span>
//               </div>
//               <div className="ucb-list">
//                 <b>Total Business</b>
//                 <span>
//                   {convertToINRFormat(parseInt(response?.totalBusiness) ?? 0)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default React.memo(Business);

import React, { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import useApiRequest from "../../../../Hooks/apiReq";
import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
import { convertToINRFormat } from "../../../../Utils/INRConvert";
import { APP_VERSION } from "../../../../Utils/AppVersion";
import { IoIosBusiness } from "react-icons/io";
const Business = () => {
  const { loading, sendApiRequest } = useApiRequest();
  const [response, setResponse] = useState({});
  const [monthlyData, setMonthlyData] = useState([]);
  // --- NEW STATE FOR VISIBILITY ---
  const now = new Date();
  const [FromDate] = useState(new Date(now.getFullYear(), now.getMonth(), 1));
  const [ToDate] = useState(new Date());
  const [previous, setPrevious] = useState({ fromdate: null, todate: null });
  // Helper function to handle masking logic
  // inside Business.js
  const [isVisible, setIsVisible] = useState(false);
  // const renderAmount = (value) => {
  //   const amount = value?.toString() || "0";
  //   return isVisible
  //     ? convertToINRFormat(amount)
  //     : "₹" + parseInt(amount).toString().replace(/\d/g, "*");
  // };

  const renderAmount = (value) => {
    const amount = value?.toString() || "0";
    if (isVisible) {
      return convertToINRFormat(amount);
    }
    const length = Math.max(3, amount.length);
    return "₹ " + "*".repeat(length);
  };
  // Toggle visibility

  const toggleVisibility = () => setIsVisible(!isVisible);

  // Example usage in JSX:
  <div className="ucb-list">
    <b>Self Business (S.B.)</b>
    <span>{renderAmount(response?.totalSelfBusiness)}</span>
  </div>;

  const fetchBusinessDetails = (from, to) => {
    if (
      JSON.stringify(previous) ===
      JSON.stringify({ fromdate: from, todate: to })
    ) {
      toast.info("No changes in date range", { toastId: "business" });
      return;
    }
    // ... (rest of your existing API logic remains the same)
    const formattedFromDate = moment(from).format("DD-MM-YYYY");
    const formattedToDate = moment(to).format("DD-MM-YYYY");
    sendApiRequest(
      "POST",
      "/Dashboard/GetBussinessCommisionRankDetails",
      {
        FromDate: formattedFromDate,
        ToDate: formattedToDate,
        action: "Bussiness",
        DeviceType: "Web",
        AppVersion: APP_VERSION,
      },
      {
        onSuccess: (res) => {
          setResponse(res?.data);
          const monthlyBusiness = res?.data?.monthwiseJson
            ? JSON.parse(res?.data?.monthwiseJson)
            : [];
          setMonthlyData(monthlyBusiness);
        },
      },
    );
    setPrevious({ fromdate: from, todate: to });
  };
  // console.log("res", response);
  return (
    <div className="col-12 col-xl-6 col-xxl-6">
      <div className="card border h-100 w-100 overflow-hidden shadow-sm">
        <div className="card-body p-2 ucbd-head">
          {loading && <SpinnerLoader />}
          <div className="row">
            <div className="col-lg-3">
              <h4 className="mt-2 fs-8">
                <span className="fas fa-building"></span>
                <IoIosBusiness size={20} />
                Business
              </h4>
            </div>
            <div className="col-lg-9 col-sm-auto">
              <div className="row g-2">
                <DateFilterBar onGo={fetchBusinessDetails} />
              </div>
            </div>
          </div>

          {/* Added cursor:pointer to the container to show it's clickable */}
          <div className="ucb-details mt-3">
            <div className="ucb-current">
              <div className="ucb-left">
                <b style={{ cursor: "pointer" }} onClick={toggleVisibility}>
                  {renderAmount(response?.assoTotalBusiness)}
                </b>
                <span>Total Business</span>
              </div>
              <div className="ucb-right">
                <b className="fw-bold">{response?.associateRank || "--"}</b>
                <span>Current Rank</span>
              </div>
            </div>

            <div className="ucb-duration headingColor">
              Business in Duration
            </div>

            <div className="ucb-list">
              <b>Self Business (S.B.)</b>
              <span
                style={{ cursor: "pointer" }}
                className="textColor"
                onClick={toggleVisibility}
              >
                {renderAmount(response?.totalSelfBusiness)}
              </span>
            </div>

            <div className="ucb-list">
              <b>Team Business (T.B.)</b>
              <span
                style={{ cursor: "pointer" }}
                className="textColor"
                onClick={toggleVisibility}
              >
                {renderAmount(response?.totalTeamBusiness)}
              </span>
            </div>

            <div className="ucb-list">
              <b>Total Business</b>
              <span
                style={{ cursor: "pointer" }}
                className="textColor"
                onClick={toggleVisibility}
              >
                {renderAmount(response?.totalBusiness)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Business);
